/* Stamps ?ea=<key> onto the cart as _early_access, which main-product reads on
   every render — including the Section Rendering re-fetch a size switch does,
   where no query string survives.

   The parameter is dropped only once a render comes back carrying the key, never
   on a successful write: a landing with no cart cookie races referral-tracking.js
   for a cart, and the losing side's write goes to a cart Shopify then discards.
   Stripping on the write would leave that visitor locked with nothing to retry. */
(function () {
  var PARAM = 'ea';
  var MAX_RELOADS = 2;

  /* Order-status / checkout page — cart attributes are already locked onto the
     order there, so there is nothing to stamp. */
  if (window.Shopify && window.Shopify.Checkout && window.Shopify.Checkout.OrderStatus) {
    return;
  }

  var key = new URLSearchParams(window.location.search).get(PARAM);
  if (!key) return;

  function dropParam() {
    var params = new URLSearchParams(window.location.search);
    params.delete(PARAM);
    var query = params.toString();
    window.history.replaceState(
      null,
      '',
      window.location.pathname + (query ? '?' + query : '') + window.location.hash
    );
  }

  var counter = 'early-access-reloads:' + key;

  if (window.__earlyAccessOnCart === key) {
    /* The budget guards the write-then-reload loop, not the visitor: once a
       render shows the key on the cart, a later fresh cart in this tab must
       get its own two attempts. */
    try {
      window.sessionStorage.removeItem(counter);
    } catch (e) {
      /* Nothing stored, nothing to reset. */
    }
    dropParam();
    return;
  }

  var reloads;
  try {
    reloads = parseInt(window.sessionStorage.getItem(counter), 10) || 0;
  } catch (e) {
    /* A browser refusing session storage refuses the cart cookie too, so the
       attribute could not persist anyway and every reload would be spent. */
    reloads = MAX_RELOADS;
  }
  if (reloads >= MAX_RELOADS) {
    dropParam();
    return;
  }

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ attributes: { _early_access: key } }),
    /* The landing link often opens straight into browsing, so a tap can start a
       navigation while this is still open and abort it. One short attribute is
       far inside the 64KB keepalive limit. */
    keepalive: true,
  })
    .then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      try {
        window.sessionStorage.setItem(counter, reloads + 1);
      } catch (e) {
        /* Reloading unbounded is worse than not unlocking. */
        dropParam();
        return;
      }
      window.location.reload();
    })
    .catch(function (error) {
      console.error('early-access: cart attribute write failed', error);
    });
})();
